import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Editor = React.lazy(() => import("@kaltura/mediaspace-features-editor"));

export const render = getDsLayoutComponentRenderer(Editor);
